var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4221 5.2076C3.49137 7.908 1.01168 17.6845 3.70029 26.7774C6.38891 35.8702 13.2277 40.8362 22.1584 38.1357C31.0891 35.4353 42.6627 30.8807 39.974 21.7879C37.2854 12.695 21.3528 2.5072 12.4221 5.2076Z",
    fill: "#EEF0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.629 24.9934V13.2319C20.629 12.7392 20.2297 12.3398 19.7369 12.3398C19.2444 12.3398 18.8448 12.7392 18.8448 13.2319V24.9934C17.2767 25.392 16.1133 26.8156 16.1133 28.5064C16.1133 30.5048 17.7388 32.1305 19.7369 32.1305C21.7351 32.1305 23.3608 30.5048 23.3608 28.5064C23.3608 26.8156 22.1972 25.392 20.629 24.9934ZM19.7369 30.3464C18.7226 30.3464 17.8975 29.5209 17.8975 28.5064C17.8975 27.4917 18.7226 26.6663 19.7369 26.6663C20.7515 26.6663 21.5766 27.4917 21.5766 28.5064C21.5766 29.5209 20.7515 30.3464 19.7369 30.3464Z",
    fill: "#1E3269",
    stroke: "#EEF0FF",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1644 22.8376V9.67793C24.1644 7.23629 22.1783 5.25 19.7369 5.25C17.2958 5.25 15.3097 7.23629 15.3097 9.67793V22.8376C13.5701 24.1974 12.5449 26.2824 12.5449 28.5066C12.5449 32.4731 15.7713 35.7 19.7369 35.7C23.7028 35.7 26.9292 32.4731 26.9292 28.5066C26.9292 26.2824 25.904 24.1974 24.1644 22.8376ZM19.7369 33.9158C16.7549 33.9158 14.3291 31.4893 14.3291 28.5066C14.3291 26.7124 15.2165 25.0384 16.7031 24.0285C16.9475 23.8624 17.0939 23.5859 17.0939 23.2904V9.67793C17.0939 8.22015 18.2796 7.03418 19.7369 7.03418C21.1945 7.03418 22.3802 8.22015 22.3802 9.67793V23.2904C22.3802 23.5859 22.5266 23.8624 22.771 24.0285C24.2576 25.0384 25.145 26.7124 25.145 28.5066C25.145 31.4893 22.7189 33.9158 19.7369 33.9158Z",
    fill: "#1E3269",
    stroke: "#EEF0FF",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6051 19.4922H26.8403C26.3476 19.4922 25.9482 19.8915 25.9482 20.3843C25.9482 20.877 26.3476 21.2764 26.8403 21.2764H29.6051C30.0976 21.2764 30.4972 20.877 30.4972 20.3843C30.4972 19.8915 30.0976 19.4922 29.6051 19.4922Z",
    fill: "#1E3269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6051 15.9238H26.8403C26.3476 15.9238 25.9482 16.3232 25.9482 16.8159C25.9482 17.3087 26.3476 17.708 26.8403 17.708H29.6051C30.0976 17.708 30.4972 17.3087 30.4972 16.8159C30.4972 16.3232 30.0976 15.9238 29.6051 15.9238Z",
    fill: "#1E3269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6051 12.3555H26.8403C26.3476 12.3555 25.9482 12.7548 25.9482 13.2476C25.9482 13.7403 26.3476 14.1396 26.8403 14.1396H29.6051C30.0976 14.1396 30.4972 13.7403 30.4972 13.2476C30.4972 12.7548 30.0976 12.3555 29.6051 12.3555Z",
    fill: "#1E3269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8403 10.5693H29.6051C30.0976 10.5693 30.4972 10.17 30.4972 9.67725C30.4972 9.18474 30.0976 8.78516 29.6051 8.78516H26.8403C26.3476 8.78516 25.9482 9.18474 25.9482 9.67725C25.9482 10.17 26.3476 10.5693 26.8403 10.5693Z",
    fill: "#1E3269"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.2998,
    y: 5.25,
    width: 30.45,
    height: 30.45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/Temperature.94797af7d4d68dff3c215305f9c0c907.svg";
export { ForwardRef as ReactComponent };